import { setContext } from "@apollo/client/link/context";
import {
  ApolloClient,
  ApolloProvider,
  from,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
import { removeTypenameFromVariables } from "@apollo/client/link/remove-typename";
import { PropsWithChildren, useMemo } from "react";

interface ApolloProviderPublicProps extends PropsWithChildren {
  ctxHeaders: Record<string, string>;
}

export const ApolloProviderPublic = ({
  ctxHeaders,
  children,
}: ApolloProviderPublicProps) => {
  const apolloLink = useMemo(
    () =>
      setContext(async (_, { headers, ...rest }) => {
        return {
          ...rest,
          headers: {
            ...headers,
            ...ctxHeaders,
          },
        };
      }),
    [ctxHeaders],
  );

  const httpLink = useMemo(
    () =>
      new HttpLink({
        uri: import.meta.env.VITE_API_SERVER_URL + "/graphql/public",
      }),
    [],
  );
  const removeTypenameLink = useMemo(() => removeTypenameFromVariables(), []);
  const link = useMemo(
    () => from([apolloLink, removeTypenameLink, httpLink]),
    [apolloLink, removeTypenameLink, httpLink],
  );

  const client = useMemo(
    () =>
      new ApolloClient({
        link,
        cache: new InMemoryCache(),
        defaultOptions: {
          watchQuery: {
            fetchPolicy: "no-cache",
          },
          query: {
            fetchPolicy: "no-cache",
          },
        },
      }),
    [link],
  );
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
